
const API_ENDPOINTS = {
  AUTH: {
    LOGIN: "admin/login",
    VERIFICATION: "verifyCode",
    RESEND: "resendVerifyCode",
    LOGOUT: " /logout",
    PROFILE: "/auth/me"
  },
  USERS: {
    LIST: "/accounts/all",
    DETAIL: (id: number) => `/accounts/detail/${id}`,
    EDIT: (id: number) => `/accounts/edit/${id}`,
    UPDATE: (id: number) => `/accounts/update/${id}`,
    PLANUPDATE: (id: number) => `/accounts/update-wix-plan/${id}`,
    WIXPRODUCTS: (id: number) => `/accounts/import-wix-products/${id}`,

    ADD: "/accounts/save",
    DELETE: `/accounts/delete`,
  },

  PLANS: {
    LIST: "/web/plan/list",
    DETAIL: (id: number) => `web/plan/show/${id}`,
    STATUS: "/web/plan/change/status",
    STORE: "/web/plan/store",
    UPDATE: (id: number) => `/web/plan/update/${id}`,
    DELETE: (id: number) => `/web/plan/delete/${id}`,
    SYNC_FEATURES: (id: number) => `/plans/${id}/features/sync`,
  },
  Features: {
    List: "/features",
    Detail: (id: number) => `/features/${id}`,
    Store: "/features",
    UPDATE: (id: number) => `/features/${id}`,
    DELETE: (id: number) => `/features/${id}`,
  },
  QUIZZES: {
    LIST: "/quizzes/list",
    DETAIL: (id: number) => `/web/plan/${id}`,
    UPDATE: (id: number) => `/users/${id}/update`,
    DELETE: (id: number) => `/quizzes/delete/${id}`,
  },
  INSPIRATION: {
    LIST: "/admin/inspiration/quizzes",
    STORE: "/admin/inspiration/quizzes",
    DELETE: (id: number) => `/admin/inspiration/quizzes/${id}`,
    DETAIL: (id: number) => `/admin/inspiration/quizzes/${id}`,
    UPDATE: (id: number) => `/admin/inspiration/quizzes/${id}`,
  },
  GUIDE_RESOURCE: {
    LIST: "/admin/guide/resources",
    STORE: "/admin/guide/resources",
    DELETE: (id: number) => `/admin/guide/resources/${id}`,
    DETAIL: (id: number) => `/admin/guide/resources/${id}`,
    UPDATE: (id: number) => `/admin/guide/resources/${id}`,
  },
  NOTIFICATIONS: {
    LIST: "/admin/notifications",
    STORE: "/admin/notifications",
    DELETE: (id: number) => `/admin/notifications/${id}`,
    DETAIL: (id: number) => `/admin/notifications/${id}`,
    UPDATE: (id: number) => `/admin/notifications/${id}`,
  },
  QUIZ_TIP: {
    LIST: "/admin/quiz/tips",
    STORE: "/admin/quiz/tips",
    DELETE: (id: number) => `/admin/quiz/tips/${id}`,
    DETAIL: (id: number) => `/admin/quiz/tips/${id}`,
    UPDATE: (id: number) => `/admin/quiz/tips/${id}`,
  },
  QUOTA: {
    LIST: "/engagement/settings/list",
    DETAIL: (id: number) => `engagement/settings/edit/${id}`,
    UPDATE: (id: number) => `engagement/settings/update/${id}`,
    DELETE: (id: number) => `engagement/settings/delete/${id}`,
  },
  LANG: {
    LIST: "/language/list",
    DETAIL: (id: number) => `/language/edit/${id}`,
    CREATE: "/language/save",
    UPDATE: (id: number) => `language/update/${id}`,
    DELETE: (id: number) => `language/delete/${id}`,
    MESSAGES: (lang: string) => `language/messages/${lang}`,
  },
  CURRENCY: {
    LIST: "/countries/list",
    DETAIL: (id: number) => `/countries/edit/${id}`,
    CREATE: "/countries/save",
    UPDATE: (id: number) => `countries/update/${id}`,
    DELETE: (id: number) => `countries/delete/${id}`,
  },
  ASSETS: {
    LIST: "/admin/assets",
    DETAIL: (id: number) => `/admin/assets/${id}`,
    CREATE: "/admin/assets",
    UPDATE: (id: number) => `/admin/assets/${id}`,
    DELETE: (id: number) => `/admin/assets/${id}`,
  },
  DASHBOARD: {
    LIST: "/loadDashboard",
    // DETAIL: (id: number) => `/countries/edit/${id}`,
    // CREATE: "/countries/save",
    // UPDATE: (id: number) => `countries/update/${id}`,
    // DELETE: (id: number) => `countries/delete/${id}`,
  },
};

export default API_ENDPOINTS;
